/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../richtext/facet.defs.js'

const $nsid = 'app.bsky.graph.starterpack'

type $nsid = typeof $nsid

export { $nsid }

/** Record defining a starter pack of actors and feeds for new users. */
type Main = {
  $type: 'app.bsky.graph.starterpack'

  /**
   * Display name for starter pack; can not be empty.
   */
  name: string
  description?: string
  descriptionFacets?: RichtextFacet.Main[]

  /**
   * Reference (AT-URI) to the list record.
   */
  list: l.AtUriString
  feeds?: FeedItem[]
  createdAt: l.DatetimeString
}

export type { Main }

/** Record defining a starter pack of actors and feeds for new users. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({
      maxGraphemes: 50,
      maxLength: 500,
      minLength: 1,
    }),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 300, maxLength: 3000 }),
    ),
    descriptionFacets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
    list: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    feeds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<FeedItem>((() => feedItem) as any),
        { maxLength: 3 },
      ),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type FeedItem = {
  $type?: 'app.bsky.graph.starterpack#feedItem'
  uri: l.AtUriString
}

export type { FeedItem }

const feedItem = /*#__PURE__*/ l.typedObject<FeedItem>(
  $nsid,
  'feedItem',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { feedItem }
